import { styled } from '@mui/material/styles'
import { DataGrid } from '@mui/x-data-grid'

import { dataGridSx, dataGridRowHoverSx } from 'src/utils/views'

export default styled(DataGrid)({
    ...dataGridSx,
    ...dataGridRowHoverSx,
    '& .MuiDataGrid-columnHeaderTitle': { fontSize: 12, fontWeight: 500, color: 'var(--ink)' },
    '& .MuiDataGrid-row': { cursor: 'pointer' },
    '& .MuiDataGrid-row.super-app-theme-selected': {
        background: 'var(--warning-bg)',
        color: 'var(--warning)',
        fontWeight: 700,
        '&:hover': {
            background: 'var(--warning-bg)'
        },
        '&.Mui-selected': {
            background: 'var(--warning-bg)',
            '&:hover': {
                background: 'var(--warning-bg)'
            }
        }
    }
})
